import Svg from '../generated/Bell';
import { Icon, type IconProps } from './Icon';

export const BellIcon = (props: IconProps) => <Icon component={Svg} name="bell" {...props} />;
